import _extends from "@babel/runtime/helpers/extends";
import React, { Suspense, useMemo } from "react";
import classNames from "classnames";
import MuiList from "@mui/material/List";
import ListItem from "../ListItem";
import ListSubheader from "../ListSubheader";
import { makeStyles } from "../Utilities/ThemeHelper";
import loadable from "@loadable/component";
const ListSortable = loadable(() => import("./ListSortable"));
const useStyles = makeStyles(theme => ({
  hasPaper: {
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 2,
    padding: 0
  },
  noPaper: {
    padding: 0,
    backgroundColor: "inherit"
  },
  sideNav: {
    background: theme.palette.background.paper,
    "& .prmbl-touchRipple": {
      color: theme.palette.primary.main
    }
  },
  li: {
    background: "inherit"
  }
}));
const List = props => {
  const {
    id,
    children,
    className,
    listItems,
    subheader,
    listSubheader,
    subheaders,
    onChange,
    wrapperStyles,
    sideNav,
    draggable,
    ReactSortableProps,
    ...otherProps
  } = props;
  const classes = useStyles();
  const items = useMemo(() => (listItems || []).map((item, index) => {
    return {
      ...item,
      id: item.id || `list-item-${index}`
    };
  }), [listItems]);
  if (!listItems && !subheaders && !children) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  const inner = items.map((item, i) => {
    const itemProps = Object.assign({}, item);
    delete itemProps["chosen"];
    return /*#__PURE__*/React.createElement(ListItem, _extends({
      key: i
    }, itemProps));
  });
  return /*#__PURE__*/React.createElement(MuiList, _extends({
    id: id
  }, otherProps, {
    className: classNames("prmbl-list", className, wrapperStyles ? classes.hasPaper : classes.noPaper, {
      [classes.sideNav]: sideNav
    }),
    subheader: subheader || listSubheader || undefined
  }), draggable ? /*#__PURE__*/React.createElement(Suspense, {
    fallback: inner
  }, /*#__PURE__*/React.createElement(ListSortable, _extends({
    id: `${id}-sortable`,
    className: `${className}-sortable`,
    listItems: items,
    onChange: onChange
  }, ReactSortableProps), inner)) : inner, children ?? subheaders?.map((sh, i) => {
    const {
      listItems,
      ListProps,
      ...otherProps
    } = sh;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: `subheader-wrapper-${i}`
    }, /*#__PURE__*/React.createElement(ListSubheader, _extends({
      id: id ? `${id}-listSubheader-${i}` : undefined
    }, otherProps)), listItems?.map((item, i) => /*#__PURE__*/React.createElement(ListItem, _extends({
      key: i
    }, item))));
  }));
};
export default List;